import * as React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import { LinearProgress, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../contexts/AppContext';
import { NavigationMenuItem } from './NavigationMenuItem';
import Button from '@mui/material/Button';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grow from '@mui/material/Grow';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';

interface NavigationMenuProps {
  sliceAmount?: number;
  size?: 'small' | 'medium' | 'large' | undefined;
}

interface ListProps {
  id: string;
  page?: string;
  code?: string;
  label: string;
  href?: string;
  width?: number;
  height?: number;
}

export const NavigationMenu = (props: NavigationMenuProps) => {
  const { sliceAmount, size } = props;
  const theme = useTheme();
  const appContext = useAppContext();
  const { t } = useTranslation('navigation_menu_b');
  const { assetUrl } = appContext.useConfig();
  const { categories, isLoading } = appContext.useCategories();
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  const [sliceIndex, setSliceIndex] = React.useState(sliceAmount);
  const belowLg = useMediaQuery(theme.breakpoints.down('lg'));
  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    // @ts-ignore
    if (event && anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  React.useEffect(() => {
    setSliceIndex(sliceAmount);

    return () => {
      setSliceIndex(10);
    };
  }, [sliceAmount]);

  return (
    <>
      {isLoading && <LinearProgress color="secondary" />}
      {categories &&
        categories
          .slice(0, sliceIndex)
          .map((item: any, index) => (
            <NavigationMenuItem
              key={index}
              title={item.name}
              href={item?.code ? `/category/${item.code}` : `${item.href}`}
              dense={true}
            />
          ))}
    </>
  );
};
